import { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { TituloPagina } from 'esocial.web.react.lib/cjs/components/util/Text';
import { useRequisicaoControlada } from 'esocial.web.react.lib/cjs/hooks/RequisicaoControlada';
import { isUndefinedOrNull, obterObjetoTodosComponentesTocados, verificarTodosComponentesTocados } from 'esocial.web.react.lib/cjs/utils/geral';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import ListaRegraValidacao from 'esocial.web.react.lib/cjs/components/form/Validation/ListaRegraValidacao';
import { ContentPreview } from 'esocial.web.react.lib/cjs/components/util/ContentPreview';
import IdentificacaoEvento from 'esocial.web.react.lib/cjs/components/util/IdentificacaoEvento';
import ExposicaoRiscov_S_01_00_00Consulta from './ExposicaoRiscov_S_01_00_00Consulta';
import ExposicaoRiscov_S_01_01_00Consulta from './ExposicaoRiscov_S_01_01_00Consulta';

const ContainerBotoesPagina = styled('div')(({ theme }) => ({
    '&': {
        marginTop: theme.spacing(6),
        display: 'flex',
        flexDirection: 'row-reverse',
    },
    '& > *': {
        marginLeft: theme.spacing(1)
    }
}));

const ContainerBotaoVoltar = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(6),
    display: 'flex',
    flexDirection: 'row'
}));

function ExposicaoRiscoConsulta({ visualizacao = false }) {
    const { idTrabalhador, idEvento, idContrato, tsv, admPreliminar } = useParams();
    const [modelo, setModelo] = useState(null);

    // Hook personalizado para requisições ao servidor
    const { get, post } = useRequisicaoControlada();
    const navigate = useNavigate();

    const processamentoResposta = (conteudoResposta) => {
        setModelo(conteudoResposta);
    };

    function voltarListagem() {
        navigate(`/exposicaoRisco/${idTrabalhador}/${idContrato}/${tsv}/${admPreliminar}`);
    }

    // Estado de campos ainda não tocados pelo usuário e formulário ainda não submetido (usado no mecanismo de validações)
    const objetoComponentesTocados = {};
    objetoComponentesTocados['formulario'] = false;

    const [componenteTocadoFormulario, setComponenteTocadoFormulario] = useState(objetoComponentesTocados);

    // Construção das regras de validação para os campos do formulário
    const [regraValidacaoFormulario, setRegraValidacaoFormulario] = useState({});

    useEffect(() => {
        const objetoRegrasValidacao = {};

        if (modelo != null) {
            objetoRegrasValidacao.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormulario);
        }

        setRegraValidacaoFormulario(objetoRegrasValidacao);
    }, [modelo, componenteTocadoFormulario]);

    const [nomeFuncaoAcaoFormularioCompletamenteValidado, setNomeFuncaoAcaoFormularioCompletamenteValidado] = useState(null);

    useEffect(() => {
        async function gerenciarAcaoFormularioCompletamenteValidado() {
            const valoresValidacaoFormulario = Object.values(regraValidacaoFormulario).filter((x) => typeof x !== 'boolean');

            if (regraValidacaoFormulario.todosComponentesTocados) {
                if (typeof nomeFuncaoAcaoFormularioCompletamenteValidado === 'string' && valoresValidacaoFormulario.length > 0 && !new ListaRegraValidacao(valoresValidacaoFormulario).existeErro()) {
                    if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'submeter') {
                        await post("/sst/exposicaoRisco/salvar", modelo, voltarListagem);
                    }
                }

                setNomeFuncaoAcaoFormularioCompletamenteValidado(null);
            }
        }

        gerenciarAcaoFormularioCompletamenteValidado();
    }, [nomeFuncaoAcaoFormularioCompletamenteValidado, regraValidacaoFormulario.todosComponentesTocados]);

    function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        setModelo({
            ...modelo,
            itemResponsavelRegistroAuxiliar: {
                cpfResponsavel: { ...modelo.itemResponsavelRegistroAuxiliar.cpfResponsavel, valor: null },
                orgaoClasse: { ...modelo.itemResponsavelRegistroAuxiliar.orgaoClasse, valor: null },
                descricaoOrgaoClasse: { ...modelo.itemResponsavelRegistroAuxiliar.descricaoOrgaoClasse, valor: null },
                numeroInscricaoOrgaoClasse: { ...modelo.itemResponsavelRegistroAuxiliar.numeroInscricaoOrgaoClasse, valor: '' },
                ufOrgaoClasse: { ...modelo.itemResponsavelRegistroAuxiliar.ufOrgaoClasse, valor: '' }
            },
            itemAgenteNocivoAuxiliar: {
                codigo: { ...modelo.itemAgenteNocivoAuxiliar.codigo, valor: '' },
                ausenciaAgenteNocivo: false,
                descricao: { ...modelo.itemAgenteNocivoAuxiliar.descricao, valor: null },
                tipoAvaliacao: { ...modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao, valor: null },
                limiteTolerancia: { ...modelo.itemAgenteNocivoAuxiliar.limiteTolerancia, valor: null },
                intensidadeConcentracao: { ...modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao, valor: null },
                unidadeMedida: { ...modelo.itemAgenteNocivoAuxiliar.unidadeMedida, valor: null },
                tecnicaMedicao: { ...modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao, valor: null },
                numeroProcessoJudicial: { ...modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial, valor: null },
                epc: {
                    utilizacaoEPC: { ...modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC, valor: null },
                    eficienciaProtecaoEPC: { ...modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC, valor: null },
                    utilizacaoEPI: { ...modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI, valor: null },
                    eficienciaProtecaoEPI: { ...modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI, valor: null },
                    listaEpis: [],
                    epIs: [],
                    epiComplemento: {
                        medidaProtecao: false,
                        condicaoFuncionamento: false,
                        usoIninterrupto: false,
                        periodicidadeTroca: false,
                        prazoValidade: false,
                        higienizacao: false
                    }
                },
            }
        });

        setComponenteTocadoFormulario(obterObjetoTodosComponentesTocados(componenteTocadoFormulario));
        setNomeFuncaoAcaoFormularioCompletamenteValidado('submeter');
    }

    async function inicializarModelo(idEvento, idContrato, tsv) {
        // Registro
        if (isUndefinedOrNull(idEvento)) {
            await get(`sst/exposicaoRisco/obterEvento/0/${idContrato}/${tsv}/${admPreliminar}/${visualizacao}`, processamentoResposta);
        }
        // Visualização ou retificação
        else {
            await get(`sst/exposicaoRisco/obterEvento/${idEvento}/${idContrato}/${tsv}/${admPreliminar}/${visualizacao}`, processamentoResposta);
        }
    }

    useEffect(() => {
        inicializarModelo(idEvento, idContrato, tsv);
    }, []);

    return (
        (modelo !== null && Object.values(regraValidacaoFormulario).length > 0) ?
            <Fragment>
                <TituloPagina>Informações sobre o ambiente de trabalho, atividades desempenhadas e exposição a agentes nocivos</TituloPagina>

                <form id="formExposicaoRisco" onSubmit={(e) => handleSubmit(e)}>
                    {/*Todas as versões acima de 01.00.00*/}
                    <Display show={modelo.versao !== 'v_S_01_00_00'}>
                        <ExposicaoRiscov_S_01_01_00Consulta modelo={modelo} setModelo={setModelo} visualizacao={visualizacao}></ExposicaoRiscov_S_01_01_00Consulta>
                    </Display>

                    {/*Apenas a versão 01.00.00*/}
                    <Display show={modelo.versao == 'v_S_01_00_00'}>
                        <ExposicaoRiscov_S_01_00_00Consulta modelo={modelo} setModelo={setModelo} visualizacao={visualizacao}></ExposicaoRiscov_S_01_00_00Consulta>
                    </Display>

                    <Display show={visualizacao}>
                        <IdentificacaoEvento idEventoXml={modelo.idEventoXml} numeroRecibo={modelo.numeroRecibo} />
                    </Display>

                    <Display show={visualizacao}>
                        <ContainerBotaoVoltar>
                            <Button variant="outlined" color="secondary" size="medium" onClick={() => navigate(-1)}>
                                Voltar
                            </Button>
                        </ContainerBotaoVoltar>
                    </Display>

                    <Display show={!visualizacao}>
                        <ContainerBotoesPagina>
                            <Button variant="contained" color="primary" size="medium" type="submit">
                                Salvar
                            </Button>
                            <Button variant="outlined" color="primary" size="medium" onClick={() => navigate(-1)}>
                                Cancelar
                            </Button>
                        </ContainerBotoesPagina>
                    </Display>
                </form>
            </Fragment > :
            <ContentPreview />
    );
}

export default ExposicaoRiscoConsulta;

